<div class="client-accounts-page p-fluid">
  <app-page-shell>
    <p-toast></p-toast>
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


    <app-page-hero eyebrow="CRM Accounts" title="Client Accounts" subtitle="Manage account-level commercial records linked to CRM clients.">
      <div actions>
        <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" [outlined]="true" (click)="loadReferenceData()"></p-button>
        <p-button label="New Account" icon="pi pi-plus" (click)="openNew()"></p-button>
      </div>
    </app-page-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-search-panel title="Search Client Accounts" [activeFilters]="activeSearchCount" [collapsed]="true" (clear)="clearSearch()" (search)="applySearch()">
      <div class="search-grid">
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-search"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input id="accountGlobalSearch" pInputText [value]="searchText()" (input)="searchText.set($any($event.target).value)" (keydown.enter)="applySearch()">
              <label for="accountGlobalSearch">Global Search</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="accountClientSearch" [options]="clientOptions()" optionLabel="label" optionValue="value" [ngModel]="crmClientFilter()" (ngModelChange)="crmClientFilter.set($event)" [showClear]="true" [filter]="true" styleClass="w-full"></p-select>
              <label for="accountClientSearch">CRM Client</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
              <p-iftaLabel>
              <input id="accountCategorySearch" pInputText [value]="categoryFilter() || ''" (input)="categoryFilter.set($any($event.target).value || null)" (keydown.enter)="applySearch()">
              <label for="accountCategorySearch">Category</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>

        <div class="field">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-send"></i></p-inputGroupAddon>
              <p-iftaLabel>
              <input id="accountSourceSearch" pInputText [value]="sourceFilter() || ''" (input)="sourceFilter.set($any($event.target).value || null)" (keydown.enter)="applySearch()">
              <label for="accountSourceSearch">Source</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
      </div>
    </app-page-search-panel>

    <app-page-data-panel title="Account Directory" [subtitle]="lastUpdatedText" [resultText]="accounts().length + ' account records'">
      <p-table
        [value]="accounts()"
        [rows]="10"
        [paginator]="true"
        [loading]="loading()"
        [rowHover]="true"
        dataKey="id"
        styleClass="p-datatable-sm p-datatable-gridlines accounts-data-table"
        [tableStyle]="{ 'min-width': '68rem' }"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} client accounts"
        [showCurrentPageReport]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>Account</th>
            <th>CRM Client</th>
            <th>Classification</th>
            <th>Ownership &amp; Managers</th>
            <th>Created</th>
            <th class="text-center" style="width: 8rem">Actions</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-account>
          <tr>
            <td>
              <div class="account-identity">
                @if (account.logoUrl) {
                  <img class="account-logo" [src]="account.logoUrl" [alt]="account.companyName + ' logo'">
                } @else {
                  <span class="account-logo account-logo-placeholder"><i class="pi pi-briefcase"></i></span>
                }
                <div class="stack-cell">
                  <span class="cell-title">{{ account.companyName }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                @if (account.crmClientId) {
                  <a class="link-button cell-title" [routerLink]="['/crm/clients', account.crmClientId]">{{ clientName(account.crmClientId) }}</a>
                } @else {
                  <span class="cell-title">Unlinked</span>
                }
                <div class="cell-meta">
                  <span><i class="pi pi-hashtag"></i>{{ account.crmClientId || '-' }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <p-tag [value]="account.category || '-'" severity="info"></p-tag>
                <div class="cell-meta">
                  <span><i class="pi pi-send"></i>{{ account.source || 'Source n/a' }}</span>
                </div>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <span class="cell-title">{{ kamName(account.kamCustomerId) }}</span>
                <div class="cell-meta">
                  <span><i class="pi pi-user"></i>{{ account.kamCustomerId || 'KAM n/a' }}</span>
                  @if (clientAccountManagerNames(account).length) {
                    <span><i class="pi pi-users"></i>{{ clientAccountManagerNames(account).join(', ') }}</span>
                  } @else {
                    <span><i class="pi pi-users"></i>Client account managers unassigned</span>
                  }
                </div>
              </div>
            </td>
            <td>
              <div class="stack-cell">
                <span class="cell-title">{{ account.createdAt ? (account.createdAt | date:'medium') : '-' }}</span>
              </div>
            </td>
            <td class="text-center">
              <div class="row-actions">
                <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary" (click)="editAccount(account)" pTooltip="Edit Account"></button>
                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger" (click)="deleteAccount(account)" pTooltip="Delete Account"></button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">
              <div class="empty-state">
                <i class="pi pi-sitemap"></i>
                <strong>No client accounts found</strong>
                <span>Create an account to segment work under a CRM client.</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </app-page-data-panel>
  </app-page-shell>
</div>

<p-dialog
  [visible]="accountDialog()"
  (visibleChange)="accountDialog.set($event)"
  [style]="{ width: '1260px', maxWidth: '98vw' }"
  [breakpoints]="{ '1300px': '96vw', '900px': '98vw' }"
  header="Client Account"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="p-fluid client-account-dialog">
  <ng-template pTemplate="content">
    <form [formGroup]="accountForm" class="account-shell">
      <aside class="account-summary">
        @if (queuedLogo(); as queued) {
          <div class="summary-icon summary-logo"><img [src]="queued.previewUrl" alt="Account logo preview"></div>
        } @else if (currentLogoUrl) {
          <div class="summary-icon summary-logo"><img [src]="currentLogoUrl" alt="Account logo"></div>
        } @else {
          <div class="summary-icon"><i class="pi pi-briefcase"></i></div>
        }
        <span class="summary-kicker">CRM account setup</span>
        <h3>{{ dialogSummaryName() }}</h3>
        <p>{{ dialogSummaryDescription() }}</p>

        <div class="summary-facts">
          <div><span>CRM client</span><strong>{{ dialogClientLabel() }}</strong></div>
          <div><span>KAM</span><strong>{{ dialogKamLabel() }}</strong></div>
          <div><span>Client account managers</span><strong>{{ dialogClientAccountManagerLabel() }}</strong></div>
        </div>
      </aside>

      <section class="account-form-panel">
        <div class="account-section">
          <div class="account-section-title">
            <i class="pi pi-sitemap"></i>
            <span>Relationship & Ownership</span>
          </div>

          <div class="account-grid two relationship-grid">
            <div class="account-field">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
                <p-iftaLabel>
                  <p-select inputId="accountCrmClientId" formControlName="crmClientId" [options]="clientOptions()" optionLabel="label" optionValue="value" [filter]="true" appendTo="body" placeholder="Select CRM client" styleClass="w-full" (onChange)="onCrmClientChanged($event.value)"></p-select>
                  <label for="accountCrmClientId">CRM Client</label>
                </p-iftaLabel>
              </p-inputGroup>
              @if (submitted() && accountForm.get('crmClientId')?.invalid) {
                <small class="p-error">CRM client is required.</small>
              }
            </div>

            <div class="account-field">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                <p-iftaLabel>
                  <p-select inputId="accountKam" formControlName="kamCustomerId" [options]="kamOptions()" optionLabel="label" optionValue="value" [filter]="true" [showClear]="true" appendTo="body" placeholder="Select KAM" styleClass="w-full"></p-select>
                  <label for="accountKam">KAM</label>
                </p-iftaLabel>
              </p-inputGroup>
            </div>
          </div>
        </div>

        <div class="account-section">
          <div class="account-section-title">
            <i class="pi pi-id-card"></i>
            <span>Account Details</span>
          </div>

          <div class="account-grid two">
            <div class="account-field span-2">
              <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
                <p-iftaLabel>
                  <input id="accountName" pInputText formControlName="companyName">
                  <label for="accountName">Account Name</label>
                </p-iftaLabel>
              </p-inputGroup>
              @if (submitted() && accountForm.get('companyName')?.invalid) {
                <small class="p-error">Account name is required.</small>
              }
            </div>

            <div class="account-field span-2 account-logo-upload-field">
              <div class="account-logo-upload-card">
                <div class="account-logo-upload-header">
                  <div>
                    <strong>Account Logo</strong>
                    <span>Upload the logo that identifies this client account (PNG, JPG, SVG).</span>
                  </div>
                  <input #accountLogoFileInput type="file" accept="image/*" class="account-logo-file-input" (change)="onLogoSelected($event)" [disabled]="saving()">
                  <p-button label="Attach Logo" icon="fa-solid fa-paperclip" severity="secondary" [outlined]="true" size="small" (onClick)="accountLogoFileInput.click()" [disabled]="saving()"></p-button>
                </div>
                @if (queuedLogo(); as queued) {
                  <div class="account-logo-file-row">
                    <img [src]="queued.previewUrl" class="account-logo-thumbnail" alt="Account logo preview">
                    <div>
                      <strong>{{ queued.file.name }}</strong>
                      <span>{{ queued.state === 'queued' ? 'Ready to upload' : (queued.progress + '% uploaded') }}</span>
                    </div>
                    <p-button icon="pi pi-times" severity="secondary" [text]="true" size="small" (onClick)="removeQueuedLogo(accountLogoFileInput)" [disabled]="saving()"></p-button>
                  </div>
                } @else if (currentLogoUrl) {
                  <div class="account-logo-file-row">
                    <img [src]="currentLogoUrl" class="account-logo-thumbnail" alt="Account logo">
                    <div>
                      <strong>Current Logo</strong>
                      <span>Attached</span>
                    </div>
                    <p-button icon="pi pi-times" severity="secondary" [text]="true" size="small" (onClick)="removeExistingLogo()" [disabled]="saving()"></p-button>
                  </div>
                } @else {
                  <div class="account-logo-empty-state">No logo selected yet.</div>
                }
              </div>
            </div>

            <div class="account-field span-2 client-account-contacts-field">
              <div class="client-account-contacts-heading">
                <div>
                  <span>Client Account Contacts</span>
                  <small>New contacts are created as customers under the selected CRM client.</small>
                </div>
                <p-button label="Add Contact" icon="pi pi-user-plus" size="small" severity="secondary" [outlined]="true" [disabled]="!clientAccountContactCompany()" (onClick)="startCreateClientAccountContact()"></p-button>
              </div>
              @if (accountForm.get('clientAccountManagerCustomerIds')?.value?.length) {
                <div class="client-account-contact-list">
                  @for (customerId of accountForm.get('clientAccountManagerCustomerIds')?.value || []; track customerId) {
                    <div class="client-account-contact-row">
                      <span><i class="pi pi-user"></i>{{ clientAccountContactName(customerId) }}</span>
                      <button type="button" pButton icon="pi pi-times" class="p-button-rounded p-button-text p-button-secondary" (click)="removeClientAccountContact(customerId)" pTooltip="Remove from this client account"></button>
                    </div>
                  }
                </div>
              } @else {
                <div class="client-account-contact-empty">
                  <i class="pi pi-users"></i>
                  <span>{{ clientAccountContactCompany() ? 'Add one or more contacts for this client account.' : 'Select a CRM client with a linked company to add contacts.' }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      </section>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <span class="account-footer-spacer"></span>
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [text]="true" (click)="hideDialog()"></p-button>
    <p-button label="Save Account" icon="pi pi-check" (click)="saveAccount()" [loading]="saving()" [disabled]="saving()"></p-button>
  </ng-template>
</p-dialog>

<app-party-quick-create-dialog
  [visible]="showClientAccountContactDialog()"
  (visibleChange)="showClientAccountContactDialog.set($event)"
  mode="customer"
  [record]="null"
  [countries]="quickCreateCountries"
  [owningCompany]="quickCreateOwningCompany"
  [contactCompany]="clientAccountContactCompany()"
  [lockContactCompany]="true"
  [defaultCountryId]="clientAccountContactCompany()?.countryId || null"
  [titleOverride]="'Add Client Account Contact'"
  submitLabel="Save Contact"
  (created)="onClientAccountContactCreated($event)">
</app-party-quick-create-dialog>
